/* Love Cashmere colour copy. Selection and lifecycle are handled by custom.js. */
(() => {
  window.LoveCashmereColourDescriptions = {
    standard: function (selectedcolour) {
        let colourDescription = '';

        switch (selectedcolour) {
			case 'Black':
				colourDescription = 'Black is a timeless, universally flattering shade that represents elegance, depth and simplicity. Strong yet understated, it anchors any outfit and pairs effortlessly with every colour, making it an essential foundation for modern, classic and minimalist styling.';
				break;

			case 'Dark Grey':
				colourDescription = 'Dark Grey is a deep, refined neutral that feels modern, calm and understated. With subtle warmth and urban sophistication, it works beautifully with both light and dark palettes, offering a sleek alternative to black for everyday or smart layering.';
				break;

			case 'Light Grey':
				colourDescription = 'Light Grey is a soft, airy neutral with a clean and contemporary feel. Its pale tone brings balance and subtle contrast to darker shades while pairing effortlessly with whites, blues and pastels for a calm, understated and versatile look.';
				break;

			case 'Dark Natural':
				colourDescription = 'Dark Natural is a rich, earthy brown inspired by undyed fibres and raw landscapes. With warm, organic undertones, it brings depth and heritage character to your look, pairing beautifully with creams, greys, navy and muted greens.';
				break;

			case 'Light Natural':
				colourDescription = 'Light Natural is a soft beige with gentle warmth, inspired by raw cashmere and unbleached fibres. Clean, elegant and understated, it complements almost every colour, offering a calm, organic base for both modern and timeless styling.';
				break;

			case 'Natural':
				colourDescription = 'Natural is a warm, organic beige tone that reflects the raw beauty of undyed fibres. Soft, earthy and effortlessly versatile, it pairs beautifully with neutrals, blues and greens, making it a timeless foundation for any wardrobe.';
				break;

			case 'Denim Blue':
				colourDescription = 'Denim Blue is a classic mid-blue inspired by vintage jeans and coastal tones. Relaxed yet refined, it adds an everyday worn-in charm to your look and pairs effortlessly with greys, whites, camel tones and deeper blues.';
				break;

			case 'Pink':
				colourDescription = 'Pink is a warm, uplifting shade with a soft, cheerful character. Fresh and lively without being overpowering, it adds a gentle pop of colour to neutrals while remaining playful, modern and easy to wear across seasons.';
				break;

			case 'Light Pink':
				colourDescription = 'Light Pink is a soft, powdery blush tone with subtle warmth. Delicate yet refined, it adds a gentle lift to neutral outfits and pairs beautifully with greys, creams and deeper tones for a romantic but contemporary feel.';
				break;

			case 'Bright Red':
				colourDescription = 'Bright Red is a vivid, statement shade full of energy and confidence. Bold and impactful, it brings warmth and drama to winter styling while pairing beautifully with black, charcoal, ivory and deep navy for contrast.';
				break;

			case 'Red':
				colourDescription = 'Red is a timeless, powerful colour symbolising warmth, confidence and passion. Strong yet classic, it adds depth to your wardrobe and pairs beautifully with neutrals like grey, navy, black and soft creams.';
				break;

			case 'Ivory White':
				colourDescription = 'Ivory White is a soft, creamy off-white with subtle warmth. More refined than stark white, it offers elegant versatility, pairing beautifully with every tone while adding a gentle softness to both classic and contemporary outfits.';
				break;

			case 'Dark Navy':
				colourDescription = 'Dark Navy is a deep, inky blue with classic appeal. Offering a softer alternative to black, it feels timeless, refined and exceptionally versatile, pairing seamlessly with neutrals, brights and earthy tones.';
				break;

			case 'Navy':
				colourDescription = 'Navy is a strong, classic blue with enduring appeal. Elegant and dependable, it works as a foundation colour in any wardrobe, pairing effortlessly with greys, creams, camels, reds and soft pastels.';
				break;

			case 'Navy Blue':
				colourDescription = 'Navy Blue is a rich, sophisticated blue that offers timeless style and versatility. With its deep tonal depth, it pairs effortlessly with nearly every colour, making it an essential neutral for modern and classic wardrobes.';
				break;

			case 'Charcoal Grey':
				colourDescription = 'Charcoal Grey is a deep, refined grey with strong modern appeal. Darker than mid-grey but softer than black, it brings structure and sophistication to outfits while working seamlessly with almost every colour palette.';
				break;

			case 'Charcoal':
				colourDescription = 'Charcoal is a dense, smoky grey with a clean, contemporary feel. Strong, neutral and endlessly wearable, it anchors bold colours while adding subtle contrast to softer tones like cream, pale blues and muted greens.';
				break;

			case 'Coal Grey':
				colourDescription = 'Coal Grey is a dark, mineral grey inspired by industrial stone and natural graphite. With cool undertones and modern depth, it offers a strong neutral base that pairs beautifully with both warm and cool colour palettes.';
				break;

			case 'Burnt Orange':
				colourDescription = 'Burnt Orange is a warm, spiced tone inspired by autumn leaves and glowing embers. With rich depth and earthy undertones, it brings warmth and character to winter outfits while pairing beautifully with browns, navy and cream.';
				break;

			case 'Deep Blue':
				colourDescription = 'Deep Blue is a rich, saturated shade inspired by ocean depths and evening skies. Bold yet refined, it adds drama and sophistication while pairing effortlessly with greys, whites, camels and other cool tones.';
				break;

			case 'Pagoda Green':
				colourDescription = 'Pagoda Green is a lively, fresh green inspired by eastern landscapes and botanical tones. Vibrant yet balanced, it adds energy and individuality to neutral outfits while pairing beautifully with navy, cream and soft greys.';
				break;

			case 'Purple':
				colourDescription = 'Purple is a deep, luxurious shade associated with creativity, richness and elegance. Bold yet refined, it adds depth to winter styling and pairs beautifully with charcoal, ivory, navy and muted pink tones.';
				break;

			case 'Vicuna':
				colourDescription = 'Vicuna is a warm, refined camel-brown inspired by natural vicuña fibre. Rich and softly golden, it offers understated luxury and pairs beautifully with creams, charcoal, navy and soft earth tones.';
				break;

			case 'Stone Grey':
				colourDescription = 'Stone Grey is a balanced, mineral-inspired grey with soft depth and quiet elegance. Neutral and versatile, it works effortlessly with warmer and cooler tones, making it ideal for everyday wear across seasons.';
				break;

			case 'Bright Green':
				colourDescription = 'Bright Green is a fresh, vivid shade full of energy and vibrancy. Inspired by new spring growth, it adds a playful but modern contrast to neutral outfits and works beautifully with grey, navy and soft creams.';
				break;

			case 'Teal Blue':
				colourDescription = 'Teal Blue is a rich blue-green shade inspired by deep waters and winter forests. With cool depth and sophistication, it adds individuality while pairing beautifully with charcoal, camel, ivory and soft metallic tones.';
				break;

			case 'Undyed':
				colourDescription = 'Undyed is a pure, natural shade that reflects cashmere in its raw, untouched state. Soft, creamy and organic, it offers understated luxury and pairs effortlessly with every other tone in your wardrobe.';
				break;

			case 'White':
				colourDescription = 'White is a fresh, clean neutral symbolising purity, simplicity and clarity. Crisp yet versatile, it brightens outfits and pairs seamlessly with every colour, making it a timeless foundation for both minimal and classic styling.';
				break;

			case 'Blue Marl':
				colourDescription = 'Blue Marl is a softly blended mix of blue tones with a subtle textured finish. Relaxed yet stylish, it offers visual depth while pairing effortlessly with greys, whites, denim tones and deeper navy shades.';
				break;

			case 'Mid Grey':
				colourDescription = 'Mid Grey is a perfectly balanced grey with smooth, neutral depth. Neither too dark nor too light, it offers easy everyday wearability and pairs effortlessly with almost any colour palette or seasonal wardrobe.';
				break;

			case 'Orange':
				colourDescription = 'Orange is a bold, warm shade inspired by autumn sunsets and citrus tones. Vibrant yet balanced, it adds energy and character while pairing beautifully with navy, greys, browns and soft neutral shades.';
				break;

			case 'Pale Grey':
				colourDescription = 'Pale Grey is a light, airy neutral with soft, cool undertones. Clean and understated, it offers an elegant base for layering while pairing beautifully with whites, pastels, deeper greys and denim tones.';
				break;

			case 'Sky Blue':
				colourDescription = 'Sky Blue is a soft, airy blue inspired by clear summer skies. Fresh and uplifting, it brings lightness to winter dressing while pairing beautifully with whites, greys, creams and soft neutral tones.';
				break;

			case 'Yellow':
				colourDescription = 'Yellow is a bright, optimistic shade that radiates warmth and positivity. Bold yet cheerful, it adds a playful accent to neutral outfits and works beautifully with greys, navy and earthy browns.';
				break;

			case 'Blue Wash':
				colourDescription = 'Blue Wash is a softly faded blue with a gentle vintage feel. Relaxed and understated, it reflects worn denim tones and pairs beautifully with light greys, whites and natural neutrals for everyday layering.';
				break;

			case 'Chamomile Yellow':
				colourDescription = 'Chamomile Yellow is a soft, buttery yellow inspired by dried chamomile flowers. Warm and delicate, it adds a gentle glow to outfits while pairing beautifully with creams, browns, greys and muted blues.';
				break;

			case 'Dark Spice':
				colourDescription = 'Dark Spice is a rich brown with cinnamon and clove undertones. Warm, earthy and comforting, it evokes autumn landscapes and pairs beautifully with cream, camel, navy and muted greens.';
				break;

			case 'Lava Grey':
				colourDescription = 'Lava Grey is a deep, intense grey inspired by volcanic rock and mineral stone. Dark and powerful with subtle texture, it adds modern edge while pairing effortlessly with soft neutrals and cool tones.';
				break;

			case 'Pale Denim':
				colourDescription = 'Pale Denim is a light, washed blue inspired by sun-faded jeans. Soft and relaxed, it brings an easy everyday charm while pairing beautifully with white, grey, camel and deeper shades of blue.';
				break;

			case 'Russet Red':
				colourDescription = 'Russet Red is a warm, autumnal red with earthy brown undertones. Inspired by falling leaves and woodland tones, it adds depth and richness while pairing beautifully with cream, charcoal and navy.';
				break;

			case 'Wine':
				colourDescription = 'Wine is a deep, luxurious red with rich burgundy and plum undertones. Inspired by fine red wines, it adds warmth and opulence while pairing beautifully with greys, navy, charcoal and soft neutral tones.';
				break;

			case 'Blonde Camel':
				colourDescription = 'Blonde Camel is a light, golden-beige shade inspired by sunlit dunes. Soft, warm and sophisticated, it pairs beautifully with creams, whites, navy and soft greys for effortless, timeless styling.';
				break;

			case 'Latte Brown':
				colourDescription = 'Latte Brown is a warm, creamy brown inspired by freshly frothed coffee. Soft and inviting, it pairs beautifully with ivory, charcoal and camel tones, adding subtle depth and comfort to your palette.';
				break;

			case 'Mink':
				colourDescription = 'Mink is a soft taupe-brown with gentle grey undertones. Elegant and understated, it offers warmth without heaviness and pairs beautifully with creams, navies, burgundies and other soft neutrals.';
				break;

			case 'Moss Green':
				colourDescription = 'Moss Green is a deep, earthy green inspired by forest floors and lichen-covered stone. Natural and grounding, it pairs beautifully with camel, navy, charcoal and warm ivory tones for a refined outdoor feel.';
				break;

			case 'Pale Pink':
				colourDescription = 'Pale Pink is a delicate blush tone with a soft, powdery finish. Subtle and elegant, it adds warmth without overpowering, pairing beautifully with greys, creams, charcoal and muted berry tones.';
				break;

			case 'Pale Yellow':
				colourDescription = 'Pale Yellow is a soft, pastel yellow with buttery warmth. Light and uplifting, it adds subtle brightness while pairing beautifully with greys, whites, denim tones and warm neutral shades.';
				break;

			case 'Silver Grey':
				colourDescription = 'Silver Grey is a cool, refined grey with subtle metallic undertones. Clean and modern, it reflects light softly while pairing beautifully with navy, black, whites and soft winter pastels.';
				break;

			case 'Baby Blue':
				colourDescription = 'Baby Blue is a soft, gentle blue with a calming, comforting feel. Light and soothing, it evokes safety and warmth, making it perfect for babywear while pairing beautifully with white, cream and pale grey tones.';
				break;

			case 'Baby Pink':
				colourDescription = 'Baby Pink is a sweet, comforting pastel pink with a soft warmth. Gentle and reassuring, it brings softness and charm while pairing beautifully with cream, white and light neutral shades.';
				break;

			case 'Fuchsia Pink':
				colourDescription = 'Fuchsia Pink is a vibrant, jewel-toned pink full of energy and confidence. Bold yet stylish, it adds instant impact and pairs beautifully with black, charcoal, navy and soft greys.';
				break;

			case 'Mustard':
				colourDescription = 'Mustard is a rich golden-yellow with earthy undertones. Inspired by autumn spices and heritage tones, it brings warmth and character while pairing beautifully with navy, charcoal, camel and soft creams.';
				break;

			case 'Admiral Blue':
				colourDescription = 'Admiral Blue is a strong, commanding deep blue inspired by naval uniforms. Bold and refined, it adds structure to your look while pairing beautifully with white, camel, grey and silver tones.';
				break;

			case 'White Sail':
				colourDescription = 'White Sail is a soft off-white with gentle warmth, inspired by sunlit canvas and coastal light. Clean, airy and elegant, it pairs beautifully with blues, neutrals and soft natural tones.';
				break;

			case 'Vintage Denim':
				colourDescription = 'Vintage Denim is a washed, mid-tone blue with soft grey undertones. Relaxed and timeless, it evokes worn-in jeans and coastal skies while pairing effortlessly with neutral and darker blue shades.';
				break;

			case 'Neon Orange':
				colourDescription = 'Neon Orange is an electrifying, high-impact orange with modern energy. Bright and unapologetic, it adds a bold contemporary edge and pairs best with simple neutrals like black, white and grey.';
				break;

			case 'Camel Pale':
				colourDescription = 'Camel Pale is a soft, sandy beige with subtle golden warmth. Light and refined, it evokes natural fibres and minimalist styling while pairing beautifully with whites, navy, greys and richer browns.';
				break;

			case 'Ice White':
				colourDescription = 'Ice White is a crisp, cool white with clean clarity. Bright and minimal, it offers a modern alternative to cream tones and pairs beautifully with cool greys, blues and monochrome styling.';
				break;

			case 'Fern Green':
				colourDescription = 'Fern Green is a deep, natural green inspired by forest foliage and soft moss tones. Earthy and calming, it adds quiet depth while pairing beautifully with camels, greys, navy and warm neutrals.';
				break;

			case 'Mercury Orange':
				colourDescription = 'Mercury Orange is a vivid, high-energy orange with a futuristic edge. Bold and intense, it delivers strong visual impact and pairs best with dark neutrals to let the colour truly stand out.';
				break;

			case 'Nero Navy':
				colourDescription = 'Nero Navy is an intense, inky navy with a modern, architectural feel. Deep and sophisticated, it offers a bold alternative to black while pairing seamlessly with white, grey and metallic tones.';
				break;

			case 'Purple Heather':
				colourDescription = 'Purple Heather is a soft, blended violet with dusty undertones. Its heathered texture adds depth and softness, creating a romantic but grounded tone that pairs beautifully with grey, navy and cream.';
				break;

            case 'Earl Grey':
                colourDescription = 'Earl Grey is a soft, muted grey with gentle warmth, reminiscent of misty mornings and classic tailoring cloth. Calm, refined and effortless to wear, it brings understated elegance to any outfit while pairing beautifully with both dark and light tones.';
                break;

            case 'Charcoal Tweed':
                colourDescription = 'Charcoal Tweed is a deep, textured grey with subtle Donegal flecks adding visual depth. Inspired by Scottish stone and winter landscapes, it offers a refined alternative to black – timeless, versatile and perfect with both soft neutrals and bold colours.';
                break;

            case 'Light Denim Tweed':
                colourDescription = 'Light Denim Tweed is an airy mid-blue with soft grey undertones and classic Donegal flecks. Reminiscent of vintage denim and coastal skies, it feels relaxed yet refined, pairing effortlessly with whites, greys, navies and natural tones.';
                break;

            case 'Light Green Tweed':
                colourDescription = 'Light Green Tweed is a soft, heathered green with earthy undertones and subtle Donegal flecks. Inspired by lichen-covered stone and spring moorland, it’s calm, natural and easy to wear with browns, creams, greys and blues.';
                break;

            case 'Mallard Blue Tweed':
                colourDescription = 'Mallard Blue Tweed is a deep teal-blue with subtle Donegal flecks for texture and depth. Inspired by the rich tones of a mallard’s plumage, it feels bold yet refined, pairing beautifully with greys, camel, cream and charcoal.';
                break;

            case 'Marsh Green Tweed':
                colourDescription = 'Marsh Green Tweed is a deep, earthy green with moss and brown undertones, lifted by subtle Donegal flecks. Inspired by peatlands and forest floors, it has a grounded, heritage feel that pairs perfectly with camel, navy and neutrals.';
                break;

            case 'Mid Grey Tweed':
                colourDescription = 'Mid Grey Tweed is a balanced, stone-inspired grey with soft Donegal flecking for added texture. Neither too light nor too dark, it’s a highly versatile neutral that works effortlessly with navy, burgundy, greens and warm natural tones.';
                break;

            case 'Turnberry':
                colourDescription = 'Turnberry is a rich berry tone with deep plum undertones, inspired by Scottish heather and coastal sunsets. Warm, elegant and expressive, it adds depth to cable textures and pairs beautifully with greys, creams, navy and charcoal.';
                break;

            case 'Sandstorm Sparkle':
                colourDescription = 'Sandstorm Sparkle is a warm sandy beige with soft camel undertones and a fine gold lurex thread running through the yarn. The subtle shimmer adds refined sparkle without overpowering, making it perfect with creams, browns and soft greys.';
                break;

            case 'Dew':
                colourDescription = 'Dew is a soft, pale neutral blending light grey and subtle beige tones. Inspired by early morning mist and cool Scottish skies, it feels fresh and calming. Elegant and easy to style with navy, charcoal, soft blues and warm neutrals.';
                break;

            case 'Haar':
                colourDescription = 'Haar is a cool, misty grey with soft blue undertones, inspired by coastal sea fog. Its gentle marled finish adds depth without heaviness. Light yet refined, it pairs beautifully with navy, denim, ivory, charcoal and soft neutral tones.';
                break;

            case 'Denim Blue Tweed':
                colourDescription = 'Denim Blue Tweed is a mid-toned blue with classic Donegal flecks, inspired by worn denim and coastal horizons. Relaxed yet refined, it’s an easy everyday colour that works beautifully with greys, creams, whites and deeper navies.';
                break;

            case 'Navy Tweed':
                colourDescription = 'Navy Tweed is a deep, classic navy with subtle flecks adding texture and interest. Timeless and dependable, it offers a refined alternative to black and pairs effortlessly with greys, camel, cream, denim and soft winter tones.';
                break;

            case 'Dark Brown Tweed':
                colourDescription = 'Dark Brown Tweed is a rich, earthy brown with soft Donegal flecks reflecting natural wool tones. Warm and grounding, it brings depth to winter palettes and pairs beautifully with cream, camel, greens, navy and neutral shades.';
                break;

            case 'Dark Grey Tweed':
                colourDescription = 'Dark Grey Tweed is a deep charcoal grey with gentle Donegal fleck detailing for subtle texture. Smart, modern and versatile, it works across casual and refined looks, pairing seamlessly with almost every colour palette.';
                break;

            case 'Dark Natural Tweed':
                colourDescription = 'Dark Natural Tweed is a raw, organic brown inspired by undyed wool and rural landscapes. Soft flecking adds texture and authenticity, making it a timeless heritage shade that pairs beautifully with creams, greens and muted blues.';
                break;

            case 'Teal Blue Tweed':
                colourDescription = 'Teal Blue Tweed is a rich blue-green with classic Donegal flecks for depth and character. Inspired by deep seas and winter forests, it’s confident yet refined – a distinctive shade that pairs perfectly with greys, navy and neutrals.';
                break;

            case 'Derby Grey':
                colourDescription = 'Derby Grey is a refined charcoal grey with subtle warmth and tonal depth. Inspired by traditional Scottish tailoring cloths, it’s a timeless, versatile neutral that works for both casual and formal wear across all seasons.';
                break;

            case 'Eilean':
                colourDescription = 'Eilean is a soft, vintage pink with a gentle dusty undertone. Named after the Gaelic word for island, it evokes quiet coastal mornings and heather tones, offering a feminine yet refined colour that lifts neutrals beautifully.';
                break;

            case 'Sand':
                colourDescription = 'Sand is a warm natural beige inspired by windswept dunes and sun-bleached stone. With soft golden undertones, it feels organic, calm and timeless – a versatile neutral that pairs effortlessly with blues, greys and earthy tones.';
                break;

            case 'Felt Grey':
                colourDescription = 'Felt Grey is a soft, warm mid-grey with subtle heathered depth, reminiscent of traditional wool felt. Neutral and understated, it offers timeless versatility and pairs effortlessly with both classic and contemporary shades.';
                break;

            case 'British Blue':
                colourDescription = 'British Blue is a deep, classic blue inspired by traditional maritime tones. Timeless and elegant, it pairs effortlessly with both casual and formal styling.';
                break;

            case 'Cardinal Red':
                colourDescription = 'Cardinal Red is a bold, rich red with warmth and intensity, inspired by traditional heritage shades. Confident and eye-catching, it adds depth and character to winter layering, pairing beautifully with neutrals and dark tones while remaining timeless and refined.';
                break;

            case 'Mischief Pink':
				colourDescription = 'Mischief Pink is a bold, vibrant magenta with luxurious depth and warmth. Playful yet refined, it adds character and confidence to any outfit, standing out beautifully against neutrals while remaining soft enough for everyday wear.'; 
				break;

			case 'Port':
				colourDescription = 'Port is a deep, sophisticated wine red with subtle brown undertones, reminiscent of aged vintage bottles and classic tailoring. Rich and timeless, it brings warmth, elegance and depth to both casual and formal winter styling.'; 
				break;

			case 'Serpentine Green':
				colourDescription = 'Serpentine Green is a deep, natural green inspired by the mossy landscapes and forests of the Scottish Borders. Earthy and grounding, it offers a calm, heritage feel while remaining versatile and effortlessly stylish.'; 
				break;
            
            case 'Drift':
                colourDescription = 'Drift is a soft, weathered grey with warm undertones, reminiscent of coastal stone and sun-faded timber. Calm and understated, it’s an easy neutral that sits effortlessly alongside both warm and cool palettes.';
                break;

            case 'Flannel Grey':
                colourDescription = 'Flannel Grey is a soft, mid-tone grey with a subtle warmth, reminiscent of classic brushed flannel and misty winter mornings. Refined and easy to wear, it’s a versatile neutral that pairs effortlessly with navy, charcoal, soft pinks and natural tones.';
                break;

			case 'Amethyst Tweed':
                colourDescription = 'Amethyst Tweed blends deep violet, heathered purples and cool midnight tones to create a rich, jewel-like shade with subtle depth. Elegant and atmospheric, it adds refined colour to winter outfits while remaining beautifully understated and versatile.';
                break;
			
			case 'Bison Tweed':
                colourDescription = 'Bison Tweed is a warm, earthy mix of natural browns and soft taupe highlights, inspired by rugged landscapes and undyed wool. Its gentle marled texture gives a rustic yet sophisticated look, making it an easy, timeless neutral for everyday wear.';
                break

			case 'Truffle Tweed':
                colourDescription = 'Truffle Tweed combines dark woodland browns with flecks of moss, bark and peat for a rich, organic finish. Deep, grounding and full of natural character, it brings a warm, heritage feel to any outfit while remaining effortlessly stylish and versatile.';
                break;

			case 'Light Denim':
                colourDescription = 'Light Denim is a soft, washed blue inspired by sun-worn denim and coastal tones. Gentle, airy and modern, it adds a fresh lightness to layered outfits, pairing beautifully with neutrals, greys and soft pastels for an effortlessly refined everyday look.';
                break;

			case 'Jean':
                colourDescription = 'Jean is a beautifully balanced mid-blue with subtle marled highlights, echoing the character of well-loved denim. Versatile and quietly sophisticated, it offers a relaxed, polished tone that complements both premium knitwear and casual winter layering.';
                break;

			case 'Indigo':
                colourDescription = 'Indigo is a deep, richly saturated navy with charcoal undertones, offering depth, refinement and timeless appeal. Its moody, elegant tone pairs effortlessly with luxury fibres, tailoring and outerwear, making it a sophisticated choice for elevated everyday styling.';
                break;

			case 'Pale Blue':
                colourDescription = 'Pale Blue is a soft, airy shade with a gentle coolness, echoing winter skies and frosted mornings. Clean, calming and beautifully understated, it brings a refined lightness to any outfit and pairs effortlessly with neutrals, greys and natural fibres.';
                break;

			case 'Bourgeois':
                colourDescription = 'Bourgeois is a rich, confident red with deep, refined undertones, inspired by classic Parisian style. Bold yet elegant, it adds warmth, vibrancy and timeless sophistication to winter accessories, creating a striking accent against both dark and neutral palettes.';
                break;

			case 'Blue':
				colourDescription = 'Blue is a rich, confident shade that evokes open skies and deep ocean tones. Calm yet striking, it brings a refined pop of colour to both neutral interiors and winter wardrobes, perfect for effortless everyday elegance.';
				break;

			case 'Porcupine':
				colourDescription = 'Porcupine is a deep, rich brown with subtle warmth and natural depth. Earthy yet refined, it evokes woodland tones and pairs beautifully with neutral outerwear, denim and autumnal shades for an understated, luxurious look.';
				break;

			case 'Hoopoe':
				colourDescription = 'Hoopoe is a warm, darker pink with soft earthy undertones. Elegant and flattering, it brings a muted blush warmth that feels modern and wearable, pairing effortlessly with greys, creams and soft browns.';
				break;

			case 'Chantilly':
				colourDescription = 'Chantilly is a delicate, pale pink with a soft creamy base. Light, refined and quietly luxurious, it offers a gentle touch of colour that complements neutral wardrobes and adds effortless elegance to everyday styling.';
				break;
			
			case 'Kiwi Green':
				colourDescription = 'Kiwi Green is a vibrant, fresh green with natural warmth. Bright yet refined, it adds an uplifting pop of colour while remaining elegant and wearable. Inspired by spring foliage, it pairs beautifully with neutrals like cream, camel and grey for a confident, contemporary look.';
				break;

			case 'Putty Grey':
				colourDescription = 'Putty Grey is a soft, balanced neutral that sits between warm stone and cool grey. Subtle and refined, it has an understated elegance that feels modern yet timeless, pairing effortlessly with both light and dark tones across your wardrobe.';
				break;

			case 'Burgundy':
				colourDescription = 'Burgundy is a deep wine red with warm undertones, offering a rich, timeless feel. Elegant and versatile, it adds depth to both neutral and darker outfits for a refined finish.';
				break;

			case 'Cosmos Blue':
				colourDescription = 'Cosmos Blue is a rich, sophisticated blue with a deep, slightly muted tone. Elegant and versatile, it brings a refined depth of colour that feels distinctive without being overpowering, pairing beautifully with soft neutrals, greys and natural shades.';
				break;

			case 'Loden Moss Green':
				colourDescription = 'Loden Moss Green is a deep, earthy green inspired by traditional loden cloth and woodland tones. Rich yet understated, it has a refined natural character that pairs effortlessly with warm neutrals, charcoal, navy and other heritage shades.';
				break;

			case 'Lapis Blue':
				colourDescription = 'Lapis Blue is a vivid, jewel-toned blue with a rich, saturated depth inspired by lapis lazuli. Striking yet sophisticated, it brings a confident burst of colour while remaining elegant and easy to pair with navy, grey, cream and other refined neutrals.';
				break;
            
            default:
                colourDescription = 'Sorry, there isn\'t a description for this colour yet.';
        }

        return colourDescription;
    },
    blankets: function (selectedcolour) {
        let colourDescription = '';

        switch (selectedcolour) {
            case 'Black':
                colourDescription = 'Black is a hotel-luxe classic that grounds any space. Draped over a sofa, folded at the foot of the bed or packed for city breaks and red-eye flights, it adds instant sophistication and works seamlessly with every interior palette.'; 
                break;

            case 'Dark Grey':
                colourDescription = 'Dark Grey is a deep, modern neutral that feels calm and cocooning. Perfect over a charcoal sofa, leather armchair or in the back of the car, it adds quiet luxury at home and makes a sleek, understated companion for travel.';
                break;

            case 'Light Grey':
                colourDescription = 'Light Grey is a soft, airy neutral that brightens without overpowering. Layer it over crisp white bedding, a pale sofa or your favourite reading chair, then roll it into your carry-on for a calm, cosy layer on planes, trains and weekend escapes.';
                break;

            case 'Dark Natural':
                colourDescription = 'Dark Natural is a rich, earthy brown that brings warmth and character to any room. It pairs beautifully with wooden floors, linen cushions and muted greens at home, and feels like a cosy, fireside wrap when you are travelling to colder places.';
                break;

            case 'Light Natural':
                colourDescription = 'Light Natural is a soft, sandy beige inspired by raw cashmere. Elegant and understated, it looks beautiful draped over a neutral sofa or end of the bed, and doubles as the perfect travel throw for beach houses, road trips and long-haul journeys.';
                break;

            case 'Natural':
                colourDescription = 'Natural is a warm, organic beige that suits almost every interior style. Whether layered with crisp whites and soft greys at home or used as a go-anywhere travel blanket in the car, on the plane or in a mountain lodge, it always feels quietly luxurious.';
                break;

            case 'Denim Blue':
                colourDescription = 'Denim Blue is a relaxed mid-blue that feels both coastal and contemporary. It adds an easy pop of colour to sofas, armchairs and guest beds, and is ideal for throwing over your shoulders on cool flights, ferry crossings or evening walks on holiday.';
                break;

            case 'Pink':
                colourDescription = 'Pink is a warm, uplifting shade that brings a soft accent to your space. Style it over a neutral sofa or layered bedding for a cheerful touch at home, then take it with you as a cosy, mood-boosting wrap for chilly flights and weekend getaways.';
                break;

            case 'Light Pink':
                colourDescription = 'Light Pink is a delicate blush that feels gentle and soothing. Beautiful in a bedroom over white or grey linens, it adds a romantic softness to your décor and makes a lovely travel companion for spa breaks, hotel stays and quiet evenings away.';
                break;

            case 'Bright Red':
                colourDescription = 'Bright Red is a vivid, statement shade that brings energy and warmth. Drape it over a neutral sofa for a festive focal point, keep it by the door for evenings in the garden, or pack it as a bold, cosy layer for winter city breaks and ski trips.';
                break;

            case 'Red':
                colourDescription = 'Red is a timeless, inviting colour that instantly makes a space feel warmer. Ideal for adding depth to living rooms and bedrooms, it also works beautifully as a comforting travel blanket for countryside escapes, cabin stays and chilly journeys home.';
                break;

            case 'Ivory White':
                colourDescription = 'Ivory White is a soft, creamy off-white that brings quiet elegance to any room. Draped over a bed, sofa or reading nook, it adds a hotel-style finish, and when travelling it feels like carrying your favourite piece of home comfort wherever you go.';
                break;

            case 'Dark Navy':
                colourDescription = 'Dark Navy is a deep, inky blue that feels tailored and refined. It looks sophisticated across a neutral sofa or at the end of the bed, and is the perfect shade to slip into your cabin bag for overnight trips, business travel and long-haul flights.';
                break;

            case 'Navy':
                colourDescription = 'Navy is a classic blue that anchors both modern and traditional interiors. Use it to frame a light sofa, layer on crisp bedding or keep in the car for last-minute adventures – it is a dependable, go-anywhere blanket for home and travel.';
                break;

            case 'Navy Blue':
                colourDescription = 'Navy Blue is a rich, versatile tone that works in almost every setting. It complements woods, neutrals and metallics in your living space, and doubles as a smart, discreet travel throw for commuting, weekends away and overnight flights.';
                break;

            case 'Charcoal Grey':
                colourDescription = 'Charcoal Grey is a deep, sophisticated grey with strong modern appeal. It brings structure and depth to sofas and beds, and is ideal for those who want a polished, city-ready blanket that moves effortlessly from home to airport lounge to hotel room.';
                break;

            case 'Charcoal':
                colourDescription = 'Charcoal is a dense, smoky grey that feels clean and contemporary. It grounds lighter interiors at home and is practical on the move, making it a perfect blanket for road trips, train journeys and evenings wrapped up on a balcony or terrace.';
                break;

            case 'Coal Grey':
                colourDescription = 'Coal Grey is a dark, mineral grey with cool, architectural depth. It pairs beautifully with minimalist décor and tonal neutrals, and its refined tone makes it an ideal travel companion for business trips, city breaks and stylish weekend escapes.';
                break;

            case 'White':
                colourDescription = 'White is a fresh, crisp neutral that brightens any space. Layer it over linen bedding or a favourite armchair for a clean, airy look at home, then slip it into your carry-on as a light, luxurious blanket for warm-weather travel and summer nights away.';
                break;
			
			case 'Undyed':
				colourDescription = 'Undyed is a pure, natural shade that reflects cashmere in its raw, untouched state. Soft, creamy and organic, it brings effortless calm to bedrooms, sofas and reading corners, and feels like a quiet luxury when wrapped around you on flights, road trips and slow weekends away.';
				break;

            default:
                colourDescription = 'Sorry, there isn\'t a description for this colour yet.';
        }

        return colourDescription;
    },
    mensKnitwear: function (selectedcolour) {
        let colourDescription = '';

        switch (selectedcolour) {
            case 'Charcoal':
			colourDescription = 'Charcoal - a deep, refined grey with subtle depth. A modern alternative to black, perfect for smart or casual wear.';
			break;

			case 'Derby Grey':
			colourDescription = 'Derby Grey - a classic mid-grey inspired by traditional tailoring. Clean, versatile and easy to style year-round.';
			break;

			case 'Denim Blue':
			colourDescription = 'Denim Blue - a relaxed mid-blue with soft washed undertones. Casual yet considered, ideal for everyday wear.';
			break;

			case 'Dark Natural':
			colourDescription = 'Dark Natural - a warm earthy brown with subtle melange texture. A heritage shade that pairs effortlessly with neutrals.';
			break;

			case 'Light Grey':
			colourDescription = 'Light Grey - a soft pale grey with a clean, modern feel. Easy to layer and perfect for year-round styling.';
			break;

			case 'Fern Green':
			colourDescription = 'Fern Green - a rich, earthy green inspired by woodland tones. Fresh, understated and effortlessly timeless.';
			break;

			case 'Black':
			colourDescription = 'Black - Timeless and versatile, this deep black delivers effortless sophistication and enduring style.';
			break;

			case 'Dark Navy':
			colourDescription = 'Dark Navy - A classic, inky blue with refined depth. Smart, understated and endlessly wearable.';
			break;

			case 'Camel':
			colourDescription = 'Camel - Warm and rich with natural undertones. A luxurious neutral that elevates any look.';
			break;

			case 'Putty Grey':
			colourDescription = 'Putty Grey - A soft, muted neutral with subtle warmth. Understated and effortlessly modern.';
			break;

			case 'Burgundy':
			colourDescription = 'Burgundy - Deep wine tones with rich character. Bold yet refined for elevated styling.';
			break;

			case 'Petrol Blue':
			colourDescription = 'Petrol Blue - A striking blend of blue and green. Contemporary, confident and distinctive.';
			break;

            default:
                colourDescription = 'Sorry, there isn\'t a description for this colour yet.';
        }

        return colourDescription;
    }
  };
  document.dispatchEvent(new CustomEvent('lc:colour-descriptions-ready'));
})();
